import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import { useEffect, useRef, useState } from 'react';
import 'leaflet/dist/leaflet.css';
import SearchBar from './SearchBar'; // Make sure you have this file
import L from 'leaflet';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { debugLog } from '../../../utils/debug';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const LeafletMap = ({ setLocation, setAddress, location, address, isMobile }) => {
  const searchRef = useRef();
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(true); // track loading

  const fetchAddress = async (lat, lng) => {
    if (!lat || !lng || isNaN(lat) || isNaN(lng)) return;

    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=en`,
        { headers: { 'Accept': 'application/json' } }
      );

      if (res.status === 429) {
        setAddress('Rate limit exceeded. Please wait...');
        return;
      }

      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

      const data = await res.json();
      debugLog('address data:', data);

      if (data && data.display_name) {
        setAddress(data.display_name);
      } else {
        setAddress('Address not found');
      }
    } catch (err) {
      console.error('Error fetching address:', err);
      setAddress('Error fetching address');
    }
  };

  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        const lat = e.latlng.lat;
        const lng = e.latlng.lng;
        setLocation({ lat, lng });
        fetchAddress(lat, lng);
      },
    });
    return null;
  };

  const searchPlace = async () => {
    const query = searchQuery;
    if (!query) return;
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`
      );
      if (!res.ok) throw new Error('Network response was not ok');
      const data = await res.json();
      if (data && data.length > 0) {
        const lat = parseFloat(data[0].lat);
        const lng = parseFloat(data[0].lon);
        setLocation({ lat, lng });
        setAddress(data[0].display_name);
      } else {
        alert('Place not found');
      }
    } catch (err) {
      console.error('Search error:', err);
      alert('Error searching for place. Please check your internet connection and try again.');
    }
  };

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          setLocation({ lat, lng });
        },
        () => {
          alert('Failed to get current location');
        }
      );
    } else {
      alert('Geolocation not supported by this browser.');
    }
  };

  // Get current location on component mount
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;
          setLocation({ lat, lng });
          setIsLoading(false);
          fetchAddress(lat, lng);
        },
        () => {
          alert('Failed to get current location');
          setIsLoading(false);
        }
      );
    } else {
      alert('Geolocation not supported by this browser.');
      setIsLoading(false);
    }
  }, []);


  // Fetch address whenever location updates
  useEffect(() => {
    if (location.lat && location.lng) {
      fetchAddress(location.lat, location.lng);
    }
  }, [location]);

  if (isLoading || !location.lat || !location.lng) {
    return <div>Loading map...</div>;
  }

  return (
    <div>
      <SearchBar ref={searchRef} onSearch={searchPlace} onGetLocation={() => getCurrentLocation()} isMobile={isMobile} setSearchQuery={setSearchQuery} searchQuery={searchQuery} />

      <MapContainer
        center={[location.lat, location.lng]}
        zoom={15}
        style={{ height: '300px', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapClickHandler />
        <Marker position={[location.lat, location.lng]} />
      </MapContainer>

      <div style={{ marginTop: 20, padding: '10px', background: '#f2f2f2' }}>
        <strong>Latitude:</strong> {location.lat} &nbsp;
        <strong>Longitude:</strong> {location.lng} <br />
        <strong>Address:</strong> {address}
      </div>
    </div>
  );
};


export default LeafletMap;
